import React from 'react';
import PropTypes from 'prop-types';
import { adopt } from 'react-adopt';
import qs from 'query-string';
import root from 'window-or-global';

import { isLegacyUrl } from 'utils';
import { GlobalConsumer } from 'site/context';
import ApplicationPage from 'site/application-page';
import RegisterPage from './register-page';

/* eslint-disable */
const RegisterState = adopt(
    {
        global: <GlobalConsumer />,
    },
    ({ global }) => ({
        ...global,
    })
);
/* eslint-enable */

const RegisterContainer = ({ location, history }) => (
    <RegisterState>
        {({ register, showFlash, user }) => {
            const { origin } = qs.parse(location.search);
            const authLinkQs = origin ? `?${qs.stringify({ origin })}` : '';
            const redirectUrl = origin || '/dashboard';
            const onRedirect =
                redirectUrl.startsWith('/') && !isLegacyUrl(redirectUrl)
                    ? () => history.replace(redirectUrl)
                    : () => {
                          root.location = redirectUrl;
                      };

            if (user) {
                onRedirect();
                return null;
            }

            return (
                <ApplicationPage>
                    <RegisterPage
                        authLinkQs={authLinkQs}
                        goBack={history.goBack}
                        onRedirect={onRedirect}
                        register={variables => register(variables)}
                        showFlash={showFlash}
                        location={location}
                        user={user}
                    />
                </ApplicationPage>
            );
        }}
    </RegisterState>
);

RegisterContainer.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string,
    }).isRequired,
    history: PropTypes.shape({
        goBack: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
    }).isRequired,
};

export default RegisterContainer;
